import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import clearSearch from "@insite/client-framework/Store/Pages/RfqMyQuotes/Handlers/ClearSearch";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/RfqMyQuotes/Handlers/ToggleFiltersOpen";
import updateSearchFields from "@MasterBluePrint/Store/Pages/RfqMyQuotes/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@MasterBluePrint/Widgets/RfqMyQuotes/SearchFieldWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import Icon from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { StyledIcon } from "@insite/mobius/Link";
import Select, { SelectProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import React, { ChangeEvent, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { CustomApplicationState } from "@MasterBluePrint/Store/CustomApplicationState";


interface OwnProps extends WidgetProps { }

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        orderNumber: state.rfqMyQuotes.getQuotesParameter.orderNumber,
        parameter: state.rfqMyQuotes.getQuotesParameter,
    };
};

const mapDispatchToProps = {
    clearSearch,
    updateSearchFields,
    toggleFiltersOpen
};

// type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface QuoteSearchClearButtonStyles {
    clearButton?: ButtonPresentationProps;
    wrapper?: SearchFieldWrapperStyles;
    filterOrderButton?: ButtonPresentationProps;
    customWrapper?: InjectableCss;
    searchDynamicDropdown?: DynamicDropdownPresentationProps;
    optionWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    productImage?: LazyImageProps;
    infoWrapper?: InjectableCss;
    autocompleteTitleText?: TypographyPresentationProps;
    autocompleteErpText?: TypographyPresentationProps;
    datePickersWrapper?: InjectableCss;
    fromDate?: DatePickerPresentationProps;
    toDate?: DatePickerPresentationProps;
    expireFromDate?: DatePickerPresentationProps;
    expireToDate?: DatePickerPresentationProps;
    select?: SelectProps;
    valueOrderTotalCSS?: InjectableCss;
    labelFont?:InjectableCss;
}


export const clearButtonStyles: QuoteSearchClearButtonStyles = {
    clearButton: {
        variant: "secondary",
        css: css`
            color: #868686;
            font-family: 'Roboto', sans-serif;
            font-size: 15px;
            letter-spacing: 0;
            line-height: 21px;
            text-align: center;
            text-decoration: underline;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            border: none;
            border: none !important;
            background: none !important;
            padding: 0;

            span {
                color: #868686 !important;
                font-weight: normal !important;
            }

            &:hover,
            &:active,
            &:focus {
                color: #868686 !important;
                border: none !important;
                background: none !important;
                padding: 0;

                span {
                    color: #868686 !important;
                    font-weight: normal !important;
                }
            }
        `,
    },
    filterOrderButton: {
        color: "primary",
        buttonType: "outline",
        css: css`
            margin-bottom: 20px;
            width: 100%;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            text-transform: uppercase;
        `,
    },
    customWrapper: {
        css: css`
            margin-top: 25px;
            padding-top: 25px;
            border-top: 1px solid #D7D7D7;
            display: flex;
            flex-direction: column;
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            width: 50px;
            height: 50px;
            margin-right: 10px;
        `,
    },
    productImage: {
        width: "50px",
        css: css`
            flex-shrink: 0;
            img {
                height: 100%;
            }
        `,
    },
    infoWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    autocompleteTitleText: {
        size: 14,
    },
    autocompleteErpText: {
        size: 14,
        css: css`
            margin-top: 5px;
        `,
    },
    datePickersWrapper: {
        css: css`
            display: flex;
        `,
    },
    fromDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                // padding-right: 5px;
            `,
        },
    },
    toDate: {
        cssOverrides: {
            inputSelect: css`
                margin-left: -3rem;
            `,
            formField: css`
                // padding-left: 5px;
            `,
        },
        labelProps: {
            color: "common.background",
        },
    },
    expireFromDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                //padding-right: 5px;
            `,
        },
    },
    expireToDate: {
        cssOverrides: {
            inputSelect: css`
                 margin-left: -3rem;
            `,
            formField: css`
                //padding-left: 5px;
            `,
        },
        labelProps: {
            color: "common.background",
        },
    },
    valueOrderTotalCSS: {
        css: css`
            display: none;
        `,
    },
    labelFont:{
        css: css`
        font-weight: 900 !important;       
        font-size: 18px !important;    
    `,
    },

};
const stylesLabel = {
    labelFont: css`
        font-weight: 900 !important;
        font-size: 18px !important;
    `
};
const styles = clearButtonStyles;

const QuoteSearchClearButton = (props: Props) => {
    const { orderNumber,  updateSearchFields, parameter } = props;
    const [setfromDate, setFDValue] = React.useState("");
    const [settoDate, setTDValue] = React.useState("");
    const [setExpireFromDate, setExpireFromDateValue] = React.useState("");
    const [setExpireToDate, setExpireToDateValue] = React.useState("");
    const [requestedByValue, setRequestedBy] = React.useState("");
    const [amountValue, setAmountValue] = React.useState("");
    const orderTotalOperators = ["Greater Than", "Less Than", "Equal To"];
    const fromDate = convertDateOnlyStringToDate(parameter.fromDate);
    const toDate = convertDateOnlyStringToDate(parameter.toDate);
    const expireFromDate = convertDateOnlyStringToDate(parameter.expireFromDate);
    const expireToDate = convertDateOnlyStringToDate(parameter.expireToDate);
    const [quoteNumberValue,setQuoteNumberValue]= React.useState("");
    const [searchInput, setSearchInput] = React.useState("");
    const [statusOperatorAmountValue, setOperatorAmountValue] = React.useState("");
    const clearSearch = () => {
        setRequestedBy("");
        setTDValue("");
        setFDValue("");
        setQuoteNumberValue("");
        setSearchInput("");
        setExpireFromDateValue("");
        setExpireToDateValue("");
        setAmountValue("");
        setOperatorAmountValue("");
    };
  

    const setFilter = () => {
        const loadParameter = {
            ...parameter,
            fromDate: setfromDate || undefined,
            toDate: settoDate || undefined,
            expireFromDate: setExpireFromDate || undefined,
            expireToDate: setExpireToDate || undefined,
            requestedBy: requestedByValue || undefined,
            quoteTotalOperator: statusOperatorAmountValue || undefined,
            orderTotal: parseFloat(amountValue) || undefined,
            orderNumber:quoteNumberValue ||undefined,
            searchInput: searchInput || undefined,
        };
        updateSearchFields(loadParameter);
        props.toggleFiltersOpen();
    };

    const handleRequestedByChange = React.useCallback((e: any) => {
        setRequestedBy(e.target.value);
    }, []);

    const handleAmountChange = React.useCallback((e: any) => {
        setAmountValue(e.target.value);
    }, []);   

    const handleQuoteNumberChange = React.useCallback((e: any) => {
        setQuoteNumberValue(e.target.value);
    }, []);

    const fromDateChangeHandler = React.useCallback((e: any) => {
        setFDValue(convertDateToDateOnlyString(e.selectedDay));
    }, []);

    const toDateChangeHandler = React.useCallback((e: any) => {
        setTDValue(convertDateToDateOnlyString(e.selectedDay));
    }, []);

    const expireFromDateChangeHandler = React.useCallback((e: any) => {
        setExpireFromDateValue(convertDateToDateOnlyString(e.selectedDay));
    }, []);

    const expireToDateChangeHandler = React.useCallback((e: any) => {
        setExpireToDateValue(convertDateToDateOnlyString(e.selectedDay));
    }, []);

    const handleTotalOperatorChange = React.useCallback((e: any) => {
        setOperatorAmountValue(e.target.value);
    }, []);
   

    const handleOrderTotalChange = React.useCallback((e: any) => {
        const noRegex = /^[0-9]*(\.[0-9]{0,2})?$/;
        if (noRegex.test(e.target.value)) {
           // setValueOrderTotal(e.target.value);
        }
    }, []);

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
           
                <label style={{ fontWeight: 500, fontSize: '15px'}}>
                    {translate("Quote #")}
                </label>            
                <TextField
                    data-test-selector="quote_filterQuoteNumber"
                    value={quoteNumberValue}               
                    type="text"
                    placeholder={translate("Enter Quote #")}
                    onChange={handleQuoteNumberChange}
                    style={{marginBottom: '1rem'}}
                />
            
            <label style={{ fontWeight: 500, fontSize: '15px'}}>
                {translate("Quote Created Date Range")}
            </label>
            <StyledWrapper {...styles.datePickersWrapper} data-test-selector="quote_filterCreatedDateRange">
                <DatePicker
                    data-test-selector="quote_filterCreatedFromDate"
                    {...styles.fromDate}
                    selectedDay={convertDateOnlyStringToDate(setfromDate)}
                    onDayChange={fromDateChangeHandler}                        
                    dateTimePickerProps={{
                        clearIcon: null,
                        maxDate: toDate,
                        ...styles.fromDate?.dateTimePickerProps,
                    }}
                />
                <label {...styles.labelFont}>
                    {translate("To")}
                </label>
                <DatePicker
                    data-test-selector="quote_filterCreatedToDate"
                    {...styles.toDate}
                    selectedDay={convertDateOnlyStringToDate(settoDate)}
                    onDayChange={toDateChangeHandler}
                    dateTimePickerProps={{
                        clearIcon: null,
                        minDate: fromDate,
                        ...styles.toDate?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>

            <label style={{ fontWeight: 500, fontSize: '15px'}}>
                {translate("Expiration Date Range")}
            </label>
            <StyledWrapper {...styles.datePickersWrapper} data-test-selector="quote_filterExpirationDateRange">
                <DatePicker
                    data-test-selector="quote_filterExpirationFromDate"
                    {...styles.expireFromDate}
                    selectedDay={convertDateOnlyStringToDate(setExpireFromDate)}
                    onDayChange={expireFromDateChangeHandler}                        
                    dateTimePickerProps={{
                        clearIcon: null,
                        maxDate: expireToDate,
                        ...styles.expireFromDate?.dateTimePickerProps,
                    }}
                />
                <label {...styles.labelFont}>
                    {translate("To")}
                </label>
                <DatePicker
                    data-test-selector="quote_filterExpirationToDate"
                    {...styles.expireToDate}
                    selectedDay={convertDateOnlyStringToDate(setExpireToDate)}
                    onDayChange={expireToDateChangeHandler}
                    dateTimePickerProps={{
                        clearIcon: null,
                        minDate: expireFromDate,
                        ...styles.expireToDate?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>

            {/* <label style={{ fontWeight: 500, fontSize: '15px'}}>
                {translate("Requested by")}
            </label>
            <TextField
                data-test-selector="quote_filterRequestedBy"
                value={requestedByValue}
                type="text"
                placeholder=""
                onChange={handleRequestedByChange}
            /> */}

            <label style={{ fontWeight: 500, fontSize: '15px'}}>
                {translate("Quote Total")}
            </label>
            <Select
                data-test-selector="quote_filterOrderTotalOperator"
                {...styles.select}
                value={statusOperatorAmountValue}
                onChange={handleTotalOperatorChange}
            >
                <option value="">{translate("Select an Option")}</option>
                {orderTotalOperators.map(operator => (
                    <option key={operator} value={operator}>
                        {translate(operator)}
                    </option>
                ))}
            </Select>
            {statusOperatorAmountValue ? (
                <div>
            <label>
                {translate("Amount")}
            </label>
            <TextField
                data-test-selector="quote_filterAmount"
                value={amountValue}
                type="number"
                placeholder=""
                onChange={handleAmountChange}
            />
            </div>
        ):""}
            <Typography as="div" {...styles.customWrapper}>
                <Button onClick={setFilter}
                    {...styles.filterOrderButton}>
                    {translate("Filter Quotes")}
                </Button>
                <Button
                    {...styles.clearButton}
                    onClick={clearSearch}
                >
                    {translate("Clear Filters")}
                </Button>
            </Typography>

        </SearchFieldWrapper>
    );

};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(QuoteSearchClearButton),
    definition: {
        group: "RFQ My Quotes",
        displayName: "Quote Search Filter Form",
    },
};

export default widgetModule;
